import React, { memo } from 'react'

const SvgComponent = (props) => (
  <svg width={20} height={20} viewBox="0 0 20 20" fill="#232323" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M20 10c0-.69-.56-1.25-1.25-1.25H4.787l6.1-6.1A1.25 1.25 0 0 0 9.12.881L1.414 8.586a2 2 0 0 0 0 2.828l7.704 7.704a1.247 1.247 0 0 0 1.764-1.762L4.787 11.25H18.75c.69 0 1.25-.56 1.25-1.25z" />
  </svg>
)

export default memo(SvgComponent)
